// ⚠️ AUTO-GENERATED FILE - DO NOT MODIFY MANUALLY
    // This file was generated by the DTO generator script.
    // Any changes will be overwritten during the next build.

    
export class IndividualTravelExpenses {
  totalIndividualTravelCost: number;
  perDiemDays: number;
  milageTrips: number;
  lodgingStays: number;
  parkingDays: number;
  tollsDays: number;
  overrideAutoCalculate: boolean;
  estimatedHours: number;
}
